import { create } from 'zustand'
import type { SalesLinkPayload, SubscribeRequest, DiscountCouponPayload } from '@/services/modules/SalesLinkService'

/**
 * Store local da LP — guarda o payload retornado pela API e os dados do form
 * em progresso, para serem usados na página de sucesso (mostrar valor pago,
 * nome do plano contratado, etc.).
 *
 * Não persiste em localStorage — quando o usuário recarrega após a sucesso,
 * a página de sucesso simplesmente mostra uma versão "genérica" sem detalhes
 * do plano.
 */
interface SalesLinkState {
  payload: SalesLinkPayload | null
  subscribeData: Partial<SubscribeRequest> | null
  appliedCoupon: DiscountCouponPayload | null
  lastContractedPlanName: string | null
  lastAmountPaid: number | null
  lastPaymentMethod: 'BOLETO' | 'CARTÃO DE CRÉDITO' | null
  lastBoletoUrl: string | null

  setPayload: (p: SalesLinkPayload | null) => void
  setSubscribeData: (d: Partial<SubscribeRequest> | null) => void
  setAppliedCoupon: (c: DiscountCouponPayload | null) => void
  recordSuccess: (
    planName: string,
    amount: number,
    method: 'BOLETO' | 'CARTÃO DE CRÉDITO',
    boletoUrl: string | null,
  ) => void
  reset: () => void
}

export const useSalesLinkStore = create<SalesLinkState>((set) => ({
  payload: null,
  subscribeData: null,
  appliedCoupon: null,
  lastContractedPlanName: null,
  lastAmountPaid: null,
  lastPaymentMethod: null,
  lastBoletoUrl: null,

  setPayload: (payload) => set({ payload }),
  setSubscribeData: (subscribeData) => set({ subscribeData }),
  setAppliedCoupon: (appliedCoupon) => set({ appliedCoupon }),
  recordSuccess: (planName, amount, method, boletoUrl) =>
    set({
      lastContractedPlanName: planName,
      lastAmountPaid: amount,
      lastPaymentMethod: method,
      lastBoletoUrl: boletoUrl,
    }),
  reset: () =>
    set({
      payload: null, subscribeData: null, appliedCoupon: null,
      lastContractedPlanName: null, lastAmountPaid: null,
      lastPaymentMethod: null, lastBoletoUrl: null,
    }),
}))
